export namespace $RealCode {
    export const PRE_SIX = {
        "659001": 1,
    }
}